var map = {
	"./man_face10.glb": 106570,
	"./man_face20.glb": 97897,
	"./man_face6.glb": 37074,
	"./man_face8.glb": 33043,
	"./woman_face10.glb": 165824,
	"./woman_face20.glb": 546036,
	"./woman_face6.glb": 339932,
	"./woman_face8.glb": 847709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 874571;